import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, map, Observable } from 'rxjs';
import { environment } from '@fb/environments';

import { TranslationPathService } from './translation-path.service';

@Injectable({
  providedIn: 'root',
})
export class TranslateLoaderService implements TranslateLoader {
  #http = inject(HttpClient);
  #translationService = inject(TranslationPathService);

  getTranslation(lang: string): Observable<any> {
    const path = this.#translationService.getTranslationPath();

    return forkJoin([
      this.#http.get(`${path}/${lang}.json`),
      this.#http.get(`${path}/${environment.shortName}/${lang}.json`),
    ]).pipe(
      map(([translates, extraTranslates]) =>
        Object.assign({}, translates, extraTranslates),
      ),
    );
  }
}
